import styled from 'styled-components';

export const Container = styled.div`
	padding: 10px 0;
	margin: 0;
	border-bottom: 1px solid;
	border-color: ${props => props.borderColor};
	position: relative;
`;

export const WrapperTitle = styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;
	padding: 0 15px;
`;

export const WrapperTitleContent = styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;
	cursor: pointer;
	flex: 1;
`;

export const WrapperAddButton = styled.span`
  background: ${props => props.backgroundColor};
  border-radius: 15px;
  -webkit-transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  -o-transform: rotate(45deg);
  transform: rotate(45deg);
  display: inline-block;
  padding: 5px;
  margin-left: 5px;
  cursor: pointer;
  .Icon {
    margin: 0;
    display: block;
  }
`;

export const Title = styled.span`
	font-weight: bold;
	line-height: 30px;
	color: ${props => props.textColor};
	white-space: nowrap;
	flex: 1;
`;